"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STOPPED_BY_USER = void 0;
var STOPPED_BY_USER = exports.STOPPED_BY_USER = 'Stopped by user';